import { formatearFechaConHora, formatearFechaSinHora } from "@shared/utils/date.utils";
import IEstado from "./estado.interface";
import { IExpedienteHistorial } from "./expediente.interface";
import { IUsuario } from "./usuario.interface";

export class ExpedienteHistorial implements IExpedienteHistorial {
    id: number;
    estado: IEstado;
    estadoAnterior: IEstado;
    fecha_inicio: string;
    fecha_limite: string;
    fecha_termino: string;
    descripcion: string;
    UsuarioCrea: IUsuario;
    UsuarioModifica: IUsuario;
    cambio_manual: number;

    getFechaInicio() {
        return formatearFechaConHora(this.fecha_inicio);
    }

    getFechaInicioSinHora() {
        return formatearFechaSinHora(this.fecha_inicio);
    }

    getFechaTermino() {
        return formatearFechaConHora(this.fecha_termino);
    }

    getFechaTerminoSinHora() {
        return formatearFechaSinHora(this.fecha_termino);
    }

    getFechaLimite() {
        return formatearFechaConHora(this.fecha_limite);
    }

    getFechaLimiteSinHora() {
        return formatearFechaSinHora(this.fecha_limite);
    }
}